import React, { useEffect, useState } from "react";
import { CiCloudOff } from "react-icons/ci";
import { useScoresStore } from "../../store/scoresStore";

const ConnectivityLabel: React.FC = () => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);
  const [hasInternet, setHasInternet] = useState<boolean>(true);

  const {uploadScoresByPlayer} = useScoresStore();


  useEffect(() => {
   if (hasInternet) {
     uploadScoresByPlayer();
   }
  }, [hasInternet]);

  const checkInternetConnectivity = () => {
    const ws = new WebSocket("wss://echo.websocket.org");

    ws.onopen = () => {
      setHasInternet(true);
      // uploadScoresByPlayer();
      ws.close();
    };

    ws.onerror = () => {
      setHasInternet(false);
    };
  };
  

  useEffect(() => {
    const updateOnlineStatus = () => {
      setIsOnline(navigator.onLine);
      if (navigator.onLine) {
        checkInternetConnectivity();
      } else {
        setHasInternet(false);
      }
    };

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    updateOnlineStatus();

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  return (
    <>
      {(!isOnline || !hasInternet) && (
        <div className="fixed mt-[62px] text-center bg-orange-500 z-50 w-full flex items-center justify-center animate-slideDownFast">
          <p className="flex items-center text-white">
            <CiCloudOff className="text-2xl mr-2" />
              No internet connection
          </p>
        </div>
      )}
    </>
  );
};

export default ConnectivityLabel;


